<mat-accordion multi="false" fxFlex="0 1 100%" displayMode="flat">
    <mat-expansion-panel [expanded]="true" #mainExpansionPanel class="user-manage-course-expantion main-panel">
        <mat-expansion-panel-header>
            <mat-icon>scatter_plot</mat-icon>
            <div [ngClass]="{ 'main-info-label': mainExpansionPanel.expanded }" i18n="@@courseInfo">Course info</div>
        </mat-expansion-panel-header>

        <div fxLayout="column" class="main-body-wrapper">
            <mat-expansion-panel
                [expanded]="true"
                #mainExpansionPanelImages
                class="user-manage-course-expantion main-panel"
            >
                <mat-expansion-panel-header>
                    <mat-icon>collections</mat-icon>
                    <div
                        [ngClass]="{ 'main-info-label': mainExpansionPanelImages.expanded }"
                        i18n="@@visualAndbranding"
                    >
                        Visual and Branding
                    </div>
                </mat-expansion-panel-header>

                <div class="panel-body-wrapper">
                    <mat-expansion-panel [expanded]="true" #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>add_photo_alternate</mat-icon>
                                <div i18n="@@coverImg">Cover image</div>
                                <mat-icon class="icon-explain" matTooltip="It's the image of the course" i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.media_id }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div fxLayoutAlign="center center">
                            <app-media
                                #app_media
                                *ngIf="!resourceForm.value.media_id"
                                fxFlex="1 1 50%"
                                fxFlex.lt-md="1 1 100%"
                                formControlName="media_id"
                                [scope]="AppScope.COURSE"
                                [hasAIUploader]="true"
                                dropLabel="Drop course image"
                                i18n-dropLabel="@@dropCourseImage"
                            ></app-media>
                            <app-image-view
                                (click)="
                                    showImgModal(
                                        resourceForm.get('media_id')?.value
                                            ? resourceForm.get('media_id')?.value
                                            : 'assets/images/Default_courses_img.png'
                                    )
                                "
                                class="mt-2 mb-2"
                                *ngIf="!!resourceForm.value.media_id"
                                fxFlex="0 1 50%"
                                fxFlex.lt-md="0 1 100%"
                                [ignoreThumbnail]="true"
                                [media_id]="
                                    resourceForm.get('media_id')?.value
                                        ? resourceForm.get('media_id')?.value
                                        : 'assets/images/Default_courses_img.png'
                                "
                                paddingBottom="50%"
                                [proportional]="false"
                            >
                                <button
                                    class="remove-image"
                                    mat-icon-button
                                    color="warn"
                                    *ngIf="resourceForm.get('media_id').value as mediaId"
                                    matTooltip="Remove image"
                                    i18n-matTooltip
                                    (click)="resourceForm.get('media_id').setValue(null)"
                                    (click)="resourceForm.get('media_id').markAsDirty()"
                                >
                                    <mat-icon class="md-24">delete_outline</mat-icon>
                                </button>
                            </app-image-view>
                        </div>
                    </mat-expansion-panel>
                    <div formGroupName="medias">
                        <mat-expansion-panel #expansionPanelBG class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>photo_size_select_actual</mat-icon>
                                    <div
                                        [ngClass]="{ 'main-info-label': expansionPanelBG.expanded }"
                                        i18n="@@backgroundImg"
                                    >
                                        Background image
                                    </div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="Background for the course in the course details page."
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{
                                            green: !!resourceForm.value.medias?.background
                                        }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <div fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column">
                                <div class="imgWrapper" fxLayout="column" fxLayoutAlign="center center">
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <ng-container
                                            *ngIf="
                                                !resourceForm.get('medias').value.background ||
                                                !resourceForm.get('medias').value.background.length
                                            "
                                        >
                                            <ng-container
                                                [ngTemplateOutlet]="uploadImg"
                                                [ngTemplateOutletContext]="{
                                                    control: 'medias.background',
                                                    label: 'Drop background image'
                                                }"
                                            ></ng-container>
                                            <!-- <app-media
                                                #app_media
                                                fxFlex="1 1 50%"
                                                fxFlex.lt-md="1 1 100%"
                                                formControlName="background"
                                                [scope]="AppScope.COURSE"
                                                [hasAIUploader]="true"
                                                dropLabel="Drop course image"
                                                i18n-dropLabel="@@dropCourseImage"
                                            ></app-media> -->
                                            <!-- <app-media
                                                formControlName="background"
                                                [scope]="AppScope.COURSE"
                                                dropLabel="Drop background image"
                                                i18n-dropLabel="@@dropBGImage"
                                            ></app-media> -->
                                        </ng-container>
                                        <ng-container
                                            *ngIf="
                                                resourceForm.get('medias').value.background &&
                                                resourceForm.get('medias').value.background.length
                                            "
                                        >
                                            <ng-container
                                                *ngFor="let mediaBGId of resourceForm.get('medias').value.background"
                                            >
                                                <app-image-view
                                                    (click)="showImgModal(mediaBGId)"
                                                    [ignoreThumbnail]="true"
                                                    [media_id]="mediaBGId"
                                                    [proportional]="false"
                                                >
                                                    <button
                                                        class="remove-image"
                                                        mat-icon-button
                                                        color="warn"
                                                        matTooltip="Remove image"
                                                        i18n-matTooltip
                                                        (click)="
                                                            resourceForm.get('medias').get('background').setValue(null);
                                                            resourceForm.get('medias').get('background').markAsDirty()
                                                        "
                                                    >
                                                        <mat-icon class="md-24">delete_outline</mat-icon>
                                                    </button>
                                                </app-image-view>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                        <!-- Trailer  -->
                        <mat-expansion-panel #trailerExpansionPanel class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>video_library</mat-icon>
                                    <div i18n>Trailer</div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="Video presentation of this course presenting it with a trailer"
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <mat-icon
                                        *ngIf="!Utils.isEmpty(resourceForm.value.medias?.trailer)"
                                        class="md-24"
                                        class="remove-trailer"
                                        (click)="videoLinkControl.clearMedia()"
                                        >delete_outline</mat-icon
                                    >
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{ green: !!resourceForm.get('medias.trailer')?.value }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <!-- <app-resource-control-trailer
                                [formControl]="resourceForm.get('medias.trailer') | cast"
                                label="Upload trailer"
                                i18n-label="@@uploadTrailer"
                            ></app-resource-control-trailer> -->
                            <app-video-link-control
                                class="trailer-uploader-wrapper"
                                [formControl]="resourceForm.get('medias.trailer') | cast"
                                [uploaderBtnLabel]="'Upload trailer'"
                                i18n-uploaderBtnLabel="@@uploadTrailer"
                                [resourceId]="resource?.id"
                                [canRemoveMedia]="false"
                            ></app-video-link-control>
                            <!-- <ng-container
                                *ngIf="!resourceForm.value?.medias?.trailer?.length"
                                [ngTemplateOutlet]="mediaFileUploader"
                                [ngTemplateOutletContext]="{ controlName: 'trailer' }"
                            >
                            </ng-container> -->

                            <!-- <ng-container
                                *ngIf="!resourceForm.value?.medias?.trailer?.length"
                                [ngTemplateOutlet]="uploadImg"
                                [ngTemplateOutletContext]="{
                                    control: 'trailer',
                                    label: 'Upload trailer'
                                }"
                            ></ng-container> -->

                            <!-- <app-media-view
                                *ngIf="resourceForm.value?.medias?.trailer?.length"
                                fxLayoutAlign="center center"
                                fxFlex="0 0 90%"
                                [media_id]="resourceForm.value?.medias?.trailer[0].toString()"
                            >
                                <button
                                    class="remove-file"
                                    color="warn"
                                    type="button"
                                    fxFlex="0 1 auto"
                                    mat-icon-button
                                    matTooltip="Remove file"
                                    i18n-matTooltip
                                    (click)="resourceForm.get('medias').patchValue({ trailer: '' })"
                                >
                                    <mat-icon class="md-24">delete_outline</mat-icon>
                                </button>
                            </app-media-view> -->
                        </mat-expansion-panel>
                        <!-- Presentation  -->
                        <mat-expansion-panel #presentationExpansionPanel class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>personal_video</mat-icon>
                                    <div i18n>Presentation</div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="Video presentation of this course"
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <mat-icon
                                        *ngIf="!Utils.isEmpty(resourceForm.value.medias?.presentation)"
                                        class="md-24"
                                        class="remove-trailer"
                                        (click)="presentationVideoLinkControl.clearMedia()"
                                        >delete_outline</mat-icon
                                    >
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{ green: !!resourceForm.get('medias.presentation')?.value }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <app-video-link-control
                                #presentationVideoLinkControl
                                class="trailer-uploader-wrapper"
                                [formControl]="resourceForm.get('medias.presentation') | cast"
                                uploaderBtnLabel="Upload presentation"
                                i18n-uploaderBtnLabel
                                mediaKind="presentation"
                                mediaPromptStateKey="video/presentation"
                                [resourceId]="resource?.id"
                                [canRemoveMedia]="false"
                            ></app-video-link-control>
                        </mat-expansion-panel>
                        <mat-expansion-panel #expansionPanelScreenShot class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>center_focus_strong</mat-icon>
                                    <div
                                        [ngClass]="{ 'main-info-label': expansionPanelScreenShot.expanded }"
                                        i18n="@@screenshotImg"
                                    >
                                        Screenshot image
                                    </div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="A thumbnail from the video (or a homepage) This image is a Screenshot from the creator to be uploaded."
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{
                                            green: !!resourceForm.value.medias?.screenshot
                                        }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <div fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column">
                                <div class="imgWrapper" fxLayout="column" fxLayoutAlign="center center">
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <ng-container
                                            *ngIf="
                                                !resourceForm.get('medias').value.screenshot ||
                                                !resourceForm.get('medias').value.screenshot.length
                                            "
                                        >
                                            <ng-container
                                                [ngTemplateOutlet]="uploadImg"
                                                [ngTemplateOutletContext]="{
                                                    control: 'medias.screenshot',
                                                    label: 'Drop screenshot image'
                                                }"
                                            ></ng-container>
                                            <!-- <app-media
                                                formControlName="screenshot"
                                                [scope]="AppScope.COURSE"
                                                dropLabel="Drop screenshot image"
                                                i18n-dropLabel="@@dropScreenshotImage"
                                            ></app-media> -->
                                        </ng-container>
                                        <ng-container
                                            *ngIf="
                                                resourceForm.get('medias').value.screenshot &&
                                                resourceForm.get('medias').value.screenshot.length
                                            "
                                        >
                                            <ng-container
                                                *ngFor="
                                                    let mediaScreenShotId of resourceForm.get('medias').value.screenshot
                                                "
                                            >
                                                <app-image-view
                                                    (click)="showImgModal(mediaScreenShotId)"
                                                    [media_id]="mediaScreenShotId"
                                                    [ignoreThumbnail]="true"
                                                    [proportional]="false"
                                                >
                                                    <button
                                                        class="remove-image"
                                                        mat-icon-button
                                                        color="warn"
                                                        matTooltip="Remove image"
                                                        i18n-matTooltip
                                                        (click)="
                                                            resourceForm.get('medias').get('screenshot').setValue(null);
                                                            resourceForm.get('medias').get('screenshot').markAsDirty()
                                                        "
                                                    >
                                                        <mat-icon class="md-24">delete_outline</mat-icon>
                                                    </button>
                                                </app-image-view>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel #expansionPanelpublisher class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>fitbit</mat-icon>
                                    <div
                                        [ngClass]="{ 'main-info-label': expansionPanelpublisher.expanded }"
                                        i18n="@@publisherLogo"
                                    >
                                        Publisher logo
                                    </div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="The displayed logo in the course registeration page, this will affect when you make the course as public, You academy logo will always appear if you published the course."
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{
                                            green: !!resourceForm.value.collaboration?.view?.metadata?.publisher_logo
                                        }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-container *ngIf="customer">
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <div
                                        fxLayout="row"
                                        fxLayoutAlign="center center"
                                        *ngIf="resourceForm.value.collaboration?.view?.metadata?.publisher_logo"
                                        class="mt-1 mb-1 w-100"
                                    >
                                        <app-image-view
                                            [proportional]="false"
                                            [ignoreThumbnail]="true"
                                            [media_id]="
                                                resourceForm.value.collaboration?.view?.metadata?.publisher_logo
                                            "
                                            class="landing-bg-customer"
                                        >
                                            <button
                                                class="remove-file"
                                                color="warn"
                                                fxFlex="0 1 auto"
                                                mat-icon-button
                                                matTooltip="Remove image"
                                                i18n-matTooltip
                                                (click)="
                                                    resourceForm
                                                        .get('collaboration.view.metadata.publisher_logo')
                                                        .setValue(null);
                                                    resourceForm
                                                        .get('collaboration.view.metadata.publisher_logo')
                                                        .markAsDirty()
                                                "
                                            >
                                                <mat-icon class="md-24">delete_outline</mat-icon>
                                            </button>
                                        </app-image-view>
                                    </div>
                                    <ng-container
                                        *ngIf="!resourceForm.value.collaboration?.view?.metadata?.publisher_logo"
                                    >
                                        <input
                                            #uploadPublisherLogoInput
                                            class="publishe-upload-button"
                                            type="file"
                                            (change)="uploadPublisherLogo($event, customer)"
                                            accept="image/png, image/jpeg"
                                        />
                                        <div class="w-100" fxLayout="row" fxLayoutAlign="start center">
                                            <button
                                                *ngIf="!(publisherProgress$ | async)"
                                                class="add-publisher-logo"
                                                mat-button
                                                color="primary"
                                                (click)="selectPublisherLogo(customer)"
                                            >
                                                <mat-icon>add_circle</mat-icon>
                                                <span>Add publisher logo</span>
                                            </button>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="publisherProgress$ | async; let progressBar">
                                        <div class="publisher-logo-progress-wrapper" *ngIf="progressBar > 0">
                                            <mat-progress-bar
                                                class="progress"
                                                mode="determinate"
                                                [value]="progressBar"
                                            ></mat-progress-bar>
                                            <span class="progress-value">{{ progressBar }}%</span>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </mat-expansion-panel>
                        <mat-expansion-panel #expansionPanelDiploma class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>military_tech</mat-icon>
                                    <div
                                        [ngClass]="{ 'main-info-label': expansionPanelDiploma.expanded }"
                                        i18n="@@diplomaLogos"
                                    >
                                        Diploma logos
                                    </div>

                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="The displayed logo in the diploma."
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <mat-icon
                                        *ngIf="expansionPanelDiploma.expanded"
                                        class="reset-alignment"
                                        (click)="$event.stopPropagation(); diplomaLogos?.resetAlignment()"
                                        matTooltip="Reset alignment"
                                        i18n-matTooltip
                                        >refresh</mat-icon
                                    >
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{
                                            green: !!resourceForm.value.medias?.publisher
                                        }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <app-course-manager-diploma-logos
                                *ngIf="customer"
                                [customer]="customer"
                                [resource]="resource"
                            ></app-course-manager-diploma-logos>
                        </mat-expansion-panel>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                [expanded]="true"
                #mainExpansionPanelMain
                class="user-manage-course-expantion main-panel"
            >
                <mat-expansion-panel-header>
                    <mat-icon>settings_applications</mat-icon>
                    <div
                        [ngClass]="{ 'main-info-label': mainExpansionPanelMain.expanded }"
                        i18n="@@GeneralCourseInformation"
                    >
                        General Course Information
                    </div>
                </mat-expansion-panel-header>

                <div class="panel-body-wrapper main-info-parent">
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>group_work</mat-icon>
                                <div i18n="@@courseType">Course type</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Where the course take place. Online in KLMS or onsite, like in a classroom, conference, webinar, or blended learning (mixed)."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <mat-radio-group
                            fxLayoutAlign="start center"
                            fxLayoutGap="70px"
                            fxLayoutGap.lt-sm="20px"
                            value="online"
                            class="mt-1"
                        >
                            <mat-radio-button value="online">
                                <span i18n>Online</span>
                            </mat-radio-button>
                            <mat-radio-button [disabled]="true" (click)="onTypeChange()" value="onsite">
                                <span i18n>Onsite</span>
                            </mat-radio-button>
                            <mat-radio-button [disabled]="true" (click)="onTypeChange()" value="hybrid">
                                <span i18n>Hybrid</span>
                            </mat-radio-button>
                            <mat-radio-button [disabled]="true" (click)="onTypeChange()" value="blended">
                                <span i18n>Blended</span>
                            </mat-radio-button>
                        </mat-radio-group>
                    </mat-expansion-panel>
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>description</mat-icon>
                                <div i18n="@@description">Description</div>
                                <mat-icon class="icon-explain" matTooltip="Set course description" i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.description }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <mat-form-field class="summary-field" fxFlex="0 1 100%">
                            <textarea
                                #desc
                                matInput
                                placeholder="Write a description and list what you will learn in this course. Why the learner shall spend time and what will be the benefit of take the Course."
                                i18n-placeholder
                                minRows="3"
                                [maxlength]="defaultCourseGoalCount"
                                formControlName="description"
                            ></textarea>
                            <span *ngIf="desc.value" class="char-count">
                                {{ desc.value.length }}
                                <span>(</span>
                                {{ defaultCourseGoalCount - desc.value.length }}
                                <span i18n="@@left">left</span>
                                <span>)</span>
                            </span>
                        </mat-form-field>
                    </mat-expansion-panel>
                    <mat-expansion-panel #agendaExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>ballot</mat-icon>
                                <div i18n="@@agenda">Agenda</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="List the subjects covered in the course. The content in bullets for the lessons, modules, and classes. Suitable for onsite teaching, classroom, or webinar audience. In short, a list of what you will learn."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.agenda }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <app-text-editor
                            *ngIf="agendaExpansionPanel.expanded"
                            fxFlex="1 1 100%"
                            title="Course agenda"
                            i18n-title
                            [showTemplates]="false"
                            [displayLength]="true"
                            formControlName="agenda"
                        ></app-text-editor>
                    </mat-expansion-panel>
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>task_alt</mat-icon>
                                <div i18n="@@courseGoal">Course goal</div>
                                <mat-icon class="icon-explain" matTooltip="Set course goal" i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.goal }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field class="summary-field" fxFlex="0 1 100%">
                            <textarea
                                #goal
                                matInput
                                placeholder="Enter a goal for the course"
                                i18n-placeholder
                                minRows="3"
                                [maxlength]="defaultCourseGoalCount"
                                formControlName="goal"
                            ></textarea>
                            <span *ngIf="goal.value" class="char-count">
                                {{ goal.value.length }}
                                <span>(</span>
                                {{ defaultCourseGoalCount - goal.value.length }}
                                <span i18n="@@left">left</span>
                                <span>)</span>
                            </span>
                        </mat-form-field>
                    </mat-expansion-panel>
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>ads_click</mat-icon>
                                <div i18n>Audience</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Who is the target for the Course? The person or group who are the learners who will benefit from the knowledge covered in this course."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.audience }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field class="summary-field" fxFlex="0 1 100%">
                            <textarea
                                #audience
                                matInput
                                placeholder="Enter audience for the course"
                                i18n-placeholder
                                minRows="3"
                                [maxlength]="defaultCourseGoalCount"
                                formControlName="audience"
                            ></textarea>
                            <span *ngIf="audience.value" class="char-count">
                                {{ audience.value.length }}
                                <span>(</span>
                                {{ defaultCourseGoalCount - audience.value.length }}
                                <span i18n="@@left">left</span>
                                <span>)</span>
                            </span>
                        </mat-form-field>
                    </mat-expansion-panel>
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>tips_and_updates</mat-icon>
                                <div i18n>Pre skills</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="The prerequisite knowledge that would be required from the participant prior to the course or the event."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.pre_skills }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field class="summary-field" fxFlex="0 1 100%">
                            <textarea
                                #preSkills
                                matInput
                                placeholder="Enter pre skills for the course"
                                i18n-placeholder
                                minRows="3"
                                [maxlength]="defaultCourseGoalCount"
                                formControlName="pre_skills"
                            ></textarea>
                            <span *ngIf="preSkills.value" class="char-count">
                                {{ preSkills.value.length }}
                                <span>(</span>
                                {{ defaultCourseGoalCount - preSkills.value.length }}
                                <span i18n="@@left">left</span>
                                <span>)</span>
                            </span>
                        </mat-form-field>
                    </mat-expansion-panel>
                    <!-- Playtime and duration -->
                    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>hourglass_top</mat-icon>
                                <div i18n="@@playtimeAndDuration">Playtime and duration</div>
                                <mat-icon class="icon-explain" matTooltip="Playtime and duration" i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{
                                        green: !!resourceForm.value.time_limit || !!resourceForm.value.duration
                                    }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="mb-2" fxLayout="column" fxFlex="0 1 100%" [fxHide]="false">
                            <div
                                fxFlex="0 0 100%"
                                fxLayout="row"
                                fxLayout.lt-md="column"
                                fxLayoutAlign="space-between"
                                class="duration-picker-wrapper"
                            >
                                <div
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign="flex-start center"
                                    fxLayoutAlign.lt-md="flex-start start"
                                    fxFlex="0 0 48%"
                                    fxFlex.lt-md="0 0 100%"
                                >
                                    <span class="controller-title" i18n>Play time</span>
                                    <ngx-duration-picker
                                        formControlName="time_limit"
                                        [options]="playTimeOptions"
                                    ></ngx-duration-picker>
                                </div>
                                <div
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign="flex-start center"
                                    fxLayoutAlign.lt-md="flex-start start"
                                    fxFlex="0 0 48%"
                                    fxFlex.lt-md="0 0 100%"
                                >
                                    <span class="controller-title" i18n>Course duration</span>
                                    <ngx-duration-picker
                                        formControlName="duration"
                                        [options]="durationOptions"
                                    ></ngx-duration-picker>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <!-- Other information -->
                    <mat-expansion-panel #OtherInfoExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>info</mat-icon>
                                <div i18n="@@other_info">Other information</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Here you can add other information needed for the users who will take this course"
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <mat-slide-toggle
                                    *ngIf="OtherInfoExpansionPanel.expanded"
                                    class="other-info-toggle mr-1"
                                    (click)="$event.stopPropagation()"
                                    [formControl]="resourceForm.get('metadata.other_info') | cast"
                                    matTooltip="Hide or show for the learners before taking the course"
                                    i18n-matTooltip
                                >
                                </mat-slide-toggle>
                                <span
                                    [matTooltip]="getOtherInfoTooltipText()"
                                    class="cell-indicator"
                                    [ngClass]="{
                                        green:
                                            !!resourceForm.value.other_info && resourceForm.value.metadata?.other_info,
                                        blueBg:
                                            !!resourceForm.value.other_info && !resourceForm.value.metadata?.other_info
                                    }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field fxFlex="0 1 100%">
                            <textarea
                                #otherInfo
                                matInput
                                placeholder="Enter other information"
                                i18n-placeholder
                                minRows="2"
                                cdkTextareaAutosize
                                #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="10"
                                maxLength="1000"
                                formControlName="other_info"
                            ></textarea>
                            <span *ngIf="otherInfo.value" class="char-count">
                                {{ otherInfo.value.length }}
                                <span>(</span>
                                {{ 1000 - otherInfo.value.length }}
                                <span i18n="@@left">left</span>
                                <span>)</span>
                            </span>
                        </mat-form-field>
                    </mat-expansion-panel>
                    <!-- Sorting code -->
                    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>swap_vert</mat-icon>
                                <div i18n="@@sortingCode">Sorting Code</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="A numerical code that will be used when the Academy admin sorts the catalogue of resources in a specific order"
                                    i18n-matTooltip="@@sortingCodeExplain"
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.sorting_code }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field fxFlex="0 0 25%" fxFlex.lt-md="0 0 60px">
                            <input matInput type="number" min="0" max="100" formControlName="sorting_code" />
                        </mat-form-field>
                    </mat-expansion-panel>
                    <!-- exercise -->
                    <mat-expansion-panel #expansionPanelScreenShot class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>topic</mat-icon>
                                <div i18n>Exercise Documents</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Upload exercise document that belongs to the course for practice. It can be a documents pre-course, during course or post the course."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.get('medias.exercise')?.value?.length }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column">
                            <div class="alert-media-attach w-100">
                                <app-media-attachment
                                    #uploader
                                    type="file"
                                    dropLabel="Drop documents"
                                    i18n-dropLabel
                                    [formControl]="resourceForm.get('medias.exercise') | cast"
                                    [mediaIds]="resourceForm.value.medias?.exercise"
                                    (onUploadOrRemoveCompleted)="onUploadComplete($event)"
                                    [isCreateForm]="true"
                                    [isIconBtns]="false"
                                ></app-media-attachment>
                                <div fxLayoutAlign="center center" *ngIf="uploader.saving | async">
                                    <app-kd-logo-loading size="small"></app-kd-logo-loading>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <!-- End reward -->
                    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>military_tech</mat-icon>
                                <div i18n="@@endReward">End reward</div>

                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Set the reward for this Course. When you have a Final Test in the Course; the learner will receive either a Participation Certificate, a Diploma or a Certification."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.examination?.final_test_id }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <form [formGroup]="$any(resourceForm.get('examination'))" fxLayout="column">
                                <div fxLayoutGap="1em" fxLayoutAlign="center start" fxLayout="column" fxFlex="1 0 100%">
                                    <div fxLayoutAlign="start center" fxLayout="row" fxFlex="1 0 100%">
                                        <span fxFlex="0 0 auto" class="bold" i18n>Final test : </span>
                                        <mat-select
                                            fxFlex="1 0 auto"
                                            placeholder="Pls select final test"
                                            i18n-placeholder
                                            formControlName="final_test_id"
                                        >
                                            <mat-option
                                                *ngFor="let test of mandatoryTestResourceItems | async"
                                                [value]="test.child_resource_id"
                                            >
                                                {{ test.name }}
                                            </mat-option>
                                        </mat-select>
                                    </div>

                                    <div fxLayoutAlign="start center" fxLayout="row" fxFlex="1 0 100%">
                                        <span fxFlex="0 0 auto" class="bold" i18n>Reward type : </span>
                                        <mat-select
                                            fxFlex="1 0 auto"
                                            placeholder="Place choose reward type"
                                            i18n-placeholder
                                            formControlName="type"
                                        >
                                            <mat-option value="Participation" i18n="@@participation">
                                                Participation
                                            </mat-option>
                                            <mat-option *ngIf="itemsHaveTests" value="Diploma" i18n="@@diploma">
                                                Diploma
                                            </mat-option>
                                            <mat-option
                                                *ngIf="itemsHaveTests"
                                                value="Certification"
                                                i18n="@@certification"
                                            >
                                                Certification
                                            </mat-option>
                                        </mat-select>
                                    </div>
                                </div>

                                <div
                                    fxLayoutAlign="start center"
                                    fxLayout="row wrap"
                                    fxLayout.lt-md="column"
                                    fxFlex="1 0 100%"
                                    fxLayoutAlign.lt-md="center start"
                                >
                                    <div
                                        fxLayoutGap.gt-md="5px"
                                        fxLayoutAlign="start center"
                                        fxLayout="row"
                                        fxFlex="1 0 70%"
                                        fxFlex.lt-md="1 0 100%"
                                        class="grade-system-wrapper"
                                        *ngIf="resourceForm.get('examination')?.value.type !== 'Participation'"
                                    >
                                        <span fxFlex="0 0 auto" class="bold" fxHide.lt-md="true">
                                            <span i18n="@@gradeSystem">Grade system</span>
                                            <mat-icon
                                                class="icon-reward-explain"
                                                matTooltip="The Grade system is used for different levels of reward passing the Final test. You can define your own Grade System or use a template."
                                                i18n-matTooltip
                                                >help_outline</mat-icon
                                            >
                                            :
                                        </span>

                                        <app-admin-grade-system-control
                                            fxFlex="0 0 70%"
                                            fxFlex.lt-md="0 0 100%"
                                            [gradeControl]="
                                                resourceForm.get('examination')?.get('grade_system_id') | cast
                                            "
                                            [languageId]="resourceForm.get('language_id').value"
                                        >
                                        </app-admin-grade-system-control>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel
                [expanded]="true"
                #mainExpansionPanelSpecifications
                class="user-manage-course-expantion main-panel"
            >
                <mat-expansion-panel-header>
                    <mat-icon>content_paste</mat-icon>
                    <div
                        [ngClass]="{ 'main-info-label': mainExpansionPanelSpecifications.expanded }"
                        i18n="@@CourseDeliveryandContent"
                    >
                        Course Delivery and Content
                    </div>
                </mat-expansion-panel-header>

                <div class="panel-body-wrapper">
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>subject</mat-icon>
                                <div i18n="@@courseInstructions">Course instruction</div>
                                <mat-icon class="icon-explain" matTooltip="Set course instruction" i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.instructions }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field class="summary-field" fxFlex="0 1 100%">
                            <textarea
                                #instructions
                                matInput
                                placeholder="Enter instructions for the course"
                                i18n-placeholder
                                minRows="3"
                                [maxlength]="defaultCourseGoalCount"
                                formControlName="instructions"
                            ></textarea>
                            <span *ngIf="instructions.value" class="char-count">
                                {{ instructions.value.length }}
                                <span>(</span>
                                {{ defaultCourseGoalCount - instructions.value.length }}
                                <span i18n="@@left">left</span>
                                <span>)</span>
                            </span>
                        </mat-form-field>
                    </mat-expansion-panel>
                    <ng-container formGroupName="staff">
                        <!-- Author -->
                        <mat-expansion-panel #authorsExpansionPanel class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>account_circle</mat-icon>
                                    <div i18n>Authors in the information page</div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="Manage course author to be displayed in the information page"
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <button
                                        *ngIf="authorsExpansionPanel.expanded"
                                        mat-icon-button
                                        class="add-ins-def"
                                        matTooltip="Add custom author"
                                        (click)="
                                            $event.stopPropagation(); toggleAddCustomAuthor = !toggleAddCustomAuthor
                                        "
                                    >
                                        <mat-icon>add_circle</mat-icon>
                                    </button>
                                    <button
                                        *ngIf="authorsExpansionPanel.expanded"
                                        mat-icon-button
                                        class="add-ins-def"
                                        matTooltip="Add existing author"
                                        (click)="$event.stopPropagation(); toggleAddAuthor = !toggleAddAuthor"
                                    >
                                        <mat-icon>person_add</mat-icon>
                                    </button>
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{ green: !!resourceForm.value.staff?.manager?.length }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <div
                                    class="mt-1 w-100"
                                    fxLayout="column"
                                    fxLayoutGap="10px"
                                    fxLayoutAlign="start center"
                                >
                                    <ng-container *ngIf="user$ | async as user">
                                        <app-resource-educator-handler
                                            class="w-100 add-author-handler"
                                            *ngIf="toggleAddAuthor"
                                            [addedSearchFilters]="[{ property: 'customer', items: [user.customer_id] }]"
                                            [resource]="resource"
                                            [setDefault]="false"
                                            [formControl]="resourceForm.get('staff.manager') | cast"
                                            educatorLabel="Author"
                                            (onUpdateEducators)="onUpdateEducators($event)"
                                            i18n-educatorLabel
                                        >
                                        </app-resource-educator-handler>
                                    </ng-container>
                                    <div
                                        class="mt-1 w-100"
                                        fxLayout="row"
                                        fxLayoutGap="10px"
                                        fxLayoutAlign="start center"
                                    >
                                        <div
                                            fxLayout="column"
                                            fxLayoutGap="5px"
                                            fxLayoutAlign="start center"
                                            class="author-item"
                                            *ngFor="let author of authorsLists"
                                        >
                                            <button
                                                mat-icon-button
                                                class="remove-ins-def"
                                                matTooltip="Remove"
                                                (click)="removeAuthor(author)"
                                            >
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            <app-image-view
                                                [ngStyle]="{ minWidth: '80px' }"
                                                [isCircularImg]="true"
                                                [media_id]="author.media$"
                                                paddingBottom="80px"
                                            ></app-image-view>
                                            <span>{{ author.name }}</span>
                                        </div>
                                        <div
                                            *ngIf="toggleAddCustomAuthor"
                                            fxLayout="column"
                                            fxLayoutGap="5px"
                                            fxLayoutAlign="start center"
                                            class="custom-author-item"
                                        >
                                            <button
                                                mat-icon-button
                                                class="remove-ins-def"
                                                matTooltip="Remove"
                                                (click)="toggleAddCustomAuthor = false"
                                            >
                                                <mat-icon>close</mat-icon>
                                            </button>

                                            <button
                                                mat-icon-button
                                                class="add-custom-author-btn"
                                                matTooltip="choose author logo"
                                                (click)="selectPublisherLogo(customer)"
                                            >
                                                <mat-icon>upload</mat-icon>
                                            </button>
                                            <mat-form-field floatLabel="never" class="custom-author-name">
                                                <input
                                                    matInput
                                                    placeholder="Author Name"
                                                    i18n-placeholder
                                                    [formControl]="addAuthorName"
                                                />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </mat-expansion-panel>
                        <mat-expansion-panel #educatorExpansionPanel class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>engineering</mat-icon>
                                    <div i18n>Educator</div>
                                    <mat-icon class="icon-explain" matTooltip="Manage event educators" i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{ green: !!resourceForm.value.staff?.educator?.length }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <app-resource-educator-handler
                                    [educatorRole]="ResourceStaffRoles.EDUCATOR"
                                    *ngIf="educatorExpansionPanel.expanded"
                                    [resource]="resource"
                                    formControlName="educator"
                                    educatorLabel="Educator"
                                    i18n-educatorLabel
                                >
                                </app-resource-educator-handler>
                            </ng-template>
                        </mat-expansion-panel>
                        <!-- Host -->
                        <mat-expansion-panel #hostExpansionPanel class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>record_voice_over</mat-icon>
                                    <div i18n>Host</div>
                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="The Host is the one on the stage and he is the show or an event's central figure."
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{ green: !!resourceForm.value.staff?.host?.length }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <app-resource-educator-handler
                                    *ngIf="hostExpansionPanel.expanded"
                                    class="publisher-edu-handler"
                                    [resource]="resource"
                                    [maxNumberOfEducatore]="1"
                                    formControlName="host"
                                    searchPlaceholder="Search existing host people"
                                    [setPredefinedEducator]="!resourceForm.value.staff?.host"
                                    i18n-searchPlaceholder
                                    [educatorRole]="ResourceStaffRoles.HOST"
                                    i18n-addingLabel
                                    addingLabel="Add a new host"
                                    educatorLabel="Host"
                                    i18n-educatorLabel
                                ></app-resource-educator-handler>
                            </ng-template>
                        </mat-expansion-panel>
                        <!-- Organizer -->
                        <mat-expansion-panel #organizerExpansionPanel class="user-manage-course-expantion">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <mat-icon>person_4</mat-icon>
                                    <div i18n="@@organizer">Organizer</div>

                                    <mat-icon
                                        class="icon-explain"
                                        matTooltip="It's the academy or the company, or it could be a human who organize the event, attendess and help any one"
                                        i18n-matTooltip
                                        >help_outline</mat-icon
                                    >
                                </mat-panel-title>
                                <mat-panel-description fxLayoutAlign="end center">
                                    <span
                                        matTooltip="Indicator of field change"
                                        i18n-matTooltip
                                        class="cell-indicator"
                                        [ngClass]="{
                                            green: !!resourceForm.value.staff?.organizer?.length
                                        }"
                                    ></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <div fxLayoutGap="10px" fxLayout="column" fxFlex="0 1 100%">
                                    <app-resource-educator-handler
                                        *ngIf="organizerExpansionPanel.expanded"
                                        class="publisher-edu-handler"
                                        [resource]="resource"
                                        [maxNumberOfEducatore]="1"
                                        formControlName="organizer"
                                        [setPredefinedEducator]="!resourceForm.value.staff?.organizer"
                                        searchPlaceholder="Search existing organizers"
                                        i18n-searchPlaceholder
                                        [educatorRole]="ResourceStaffRoles.ORGANIZER"
                                        i18n-addingLabel
                                        addingLabel="Add a new organizer"
                                        educatorLabel="Organizer"
                                        i18n-educatorLabel
                                    ></app-resource-educator-handler>
                                </div>
                            </ng-template>
                        </mat-expansion-panel>
                    </ng-container>

                    <!-- Course seats -->
                    <mat-expansion-panel fxHide #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>event_seat</mat-icon>
                                <div i18n="@@courseSeats">Course seats</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Total seats can be unlimited or specified"
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{
                                        green: !!resourceForm.value.total_seats
                                    }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div
                            fxFlex="0 1 100%"
                            fxLayout.lt-md="column"
                            fxLayoutAlign="space-between center"
                            fxLayoutAlign.lt-md="space-between start"
                        >
                            <mat-checkbox
                                #unlimited
                                fxLayoutAlign="start center"
                                fxFlex="0 0 20%"
                                color="primary"
                                i18n="@@unlimited"
                                [formControl]="unlimited_seats"
                                >Unlimited</mat-checkbox
                            >
                            <mat-form-field fxFlex="0 1 80%">
                                <input
                                    matInput
                                    fxLayoutAlign="end center"
                                    type="number"
                                    min="0"
                                    placeholder="Please set total seats of the course"
                                    i18n-placeholder
                                    formControlName="total_seats"
                                />
                            </mat-form-field>
                        </div>
                    </mat-expansion-panel>
                    <!-- Extra seats -->
                    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>weekend</mat-icon>
                                <div i18n="@@extraSeats">Extra seats</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Extra seats activated when seats are full."
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.extra_seats }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <mat-form-field fxFlex="0 1 100%">
                            <input
                                matInput
                                type="number"
                                min="0"
                                placeholder="Please set extra seats needed for the course"
                                i18n-placeholder
                                formControlName="extra_seats"
                            />
                        </mat-form-field>
                    </mat-expansion-panel>
                    <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon class="prio-icon">low_priority</mat-icon>
                                <div i18n="@@priority">Priority</div>
                                <mat-icon class="icon-explain" matTooltip="Set course priority" i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.priority }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- <mat-form-field class="summary-field" fxFlex="0 1 100%">
                            <input
                                matInput
                                fxLayoutAlign="end center"
                                type="number"
                                placeholder="Please set priority"
                                i18n-placeholder="@@plsSetPriority"
                                formControlName="priority"
                            />
                        </mat-form-field> -->
                        <mat-form-field class="role-field">
                            <mat-select fxFlex="1 1 100%" formControlName="priority">
                                <mat-option value="A1" i18n>A1</mat-option>
                                <mat-option value="A2" i18n>A2</mat-option>
                                <mat-option value="A3" i18n>A3</mat-option>
                                <mat-option value="B1" i18n>B1</mat-option>
                                <mat-option value="B2" i18n>B2</mat-option>
                                <mat-option value="B3" i18n>B3</mat-option>
                                <mat-option value="C1" i18n>C1</mat-option>
                                <mat-option value="C2" i18n>C2</mat-option>
                                <mat-option value="C3" i18n>C3</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-expansion-panel>

                    <!-- Subtitle languages -->
                    <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>subtitles</mat-icon>
                                <div i18n="@@subtitles">Subtitle languages</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="If Subtitles are availible in the video for exampel ; Info Copied from TED or YouTube"
                                    i18n-matTooltip
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: !!resourceForm.value.subtitles }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div fxLayoutGap="1em" fxLayoutAlign="start center">
                            <app-title-translation
                                type="description"
                                placeholder="Enter language subtitle"
                                i18n-placeholder
                                formControlName="subtitles"
                                class="icon-resource-builder"
                                fxFlex="0 0 auto"
                            ></app-title-translation>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel #defaultNameExpansionPanel class="user-manage-course-expantion">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon class="prio-icon">display_settings</mat-icon>
                                <div i18n>Default name</div>
                                <mat-icon
                                    class="icon-explain"
                                    matTooltip="Default name of the course to be displayed in the player"
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                    [ngClass]="{ green: resourceForm.get('labelTranslation').dirty }"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div fxLayoutGap="4px" fxLayout="row" class="w-50">
                            <app-title-translation
                                type="title"
                                placeholder="Set default name"
                                i18n-placeholder
                                class="material-title-translation"
                                formControlName="labelTranslation"
                            ></app-title-translation>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                [expanded]="true"
                #mainExpansionPanelSpecifications
                class="user-manage-course-expantion main-panel"
            >
                <mat-expansion-panel-header>
                    <mat-icon>key</mat-icon>
                    <div
                        [ngClass]="{ 'main-info-label': mainExpansionPanelSpecifications.expanded }"
                        i18n="@@AccessControlandAvailability"
                    >
                        Access Control and Availability
                    </div>
                </mat-expansion-panel-header>
                <app-resource-access-and-availability
                    resourceLabel="Course"
                    i18n-resourceLabel
                    [resource]="resource"
                    [customer]="customer"
                    (onUpdateResRecurring)="updateResRecurring($event)"
                    (onEditResourceAccessPermision)="editResourceAccessPermision($event.permType, $event.value)"
                >
                    <!-- <mat-expansion-panel [expanded]="false" class="user-manage-course-expantion res-creat-manag">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>fitness_center</mat-icon>
                                <div i18n>Practices</div>
                                <mat-icon class="icon-explain" matTooltip="Add to be considered as practice"
                                    >help_outline</mat-icon
                                >
                            </mat-panel-title>
                            <mat-panel-description fxLayoutAlign="end center">
                                <span
                                    matTooltip="Indicator of field change"
                                    i18n-matTooltip
                                    class="cell-indicator"
                                ></span>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <app-resource-form-practice-control
                            #practiceControlComponent
                            [resource]="resource"
                            [typeId]="ResourceTypes.COURSE"
                            [resourceForm]="resourceForm"
                        ></app-resource-form-practice-control>
                    </mat-expansion-panel> -->
                </app-resource-access-and-availability>
            </mat-expansion-panel>
            <mat-expansion-panel
                [expanded]="true"
                #mainExpansionPanelSpecifications
                class="user-manage-course-expantion main-panel"
            >
                <mat-expansion-panel-header>
                    <mat-icon>admin_panel_settings</mat-icon>
                    <div
                        [ngClass]="{ 'main-info-label': mainExpansionPanelSpecifications.expanded }"
                        i18n="@@AdministrativeDetails"
                    >
                        Administrative Details
                    </div>
                </mat-expansion-panel-header>
                <!-- Course code -->
                <mat-expansion-panel #expansionPanel class="user-manage-course-expantion">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon>fingerprint</mat-icon>
                            <div i18n="@@SKU-ArticleNumber">SKU/ Article number</div>
                            <mat-icon
                                class="icon-explain"
                                matTooltip="Course code is a unique field, autogenerated when empty."
                                i18n-matTooltip
                                >help_outline</mat-icon
                            >
                        </mat-panel-title>
                        <mat-panel-description fxLayoutAlign="end center">
                            <span
                                matTooltip="Indicator of field change"
                                i18n-matTooltip
                                class="cell-indicator"
                                [ngClass]="{ green: !!resourceForm.value.article_code }"
                            ></span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <app-resource-article-code-form
                        fxFlex="0 1 100%"
                        formControlName="article_code"
                        [resourceId]="resource?.id"
                    ></app-resource-article-code-form>
                </mat-expansion-panel>
                <!-- Copyrights -->
                <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon>copyright</mat-icon>
                            <div i18n="@@copyrights">Copyrights</div>
                            <mat-icon class="icon-explain" matTooltip="Set course copyrights" i18n-matTooltip
                                >help_outline</mat-icon
                            >
                        </mat-panel-title>
                        <mat-panel-description fxLayoutAlign="end center">
                            <span
                                matTooltip="Indicator of field change"
                                i18n-matTooltip
                                class="cell-indicator"
                                [ngClass]="{ green: !!resourceForm.value.copyrights }"
                            ></span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <mat-form-field class="summary-field" fxFlex="0 1 100%">
                        <textarea
                            matInput
                            placeholder="Enter copyrights for the course"
                            i18n-placeholder
                            minRows="1"
                            formControlName="copyrights"
                        ></textarea>
                    </mat-form-field>
                </mat-expansion-panel>
                <!-- Promo code -->
                <mat-expansion-panel #promoCodeExpansionPanel class="user-manage-course-expantion">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon>card_giftcard</mat-icon>
                            <div i18n="@@promoCode">Promo code</div>
                            <mat-icon class="icon-explain" matTooltip="Promo code" i18n-matTooltip
                                >help_outline</mat-icon
                            >
                        </mat-panel-title>
                        <mat-panel-description fxLayoutAlign="end center">
                            <span
                                matTooltip="Indicator of field change"
                                i18n-matTooltip
                                class="cell-indicator"
                                [ngClass]="{ green: !!resourceForm.value.promo_code }"
                            ></span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <mat-form-field fxFlex="0 1 100%">
                        <input
                            matInput
                            placeholder="Please set a promo code for this course"
                            i18n-placeholder
                            formControlName="promo_code"
                        />
                    </mat-form-field>
                </mat-expansion-panel>
                <mat-expansion-panel #priceExpansionPanel class="user-manage-course-expantion">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon>local_offer</mat-icon>
                            <div i18n="@@price">Price</div>

                            <mat-icon class="icon-explain" matTooltip="Price" i18n-matTooltip>help_outline</mat-icon>
                        </mat-panel-title>
                        <mat-panel-description fxLayoutAlign="end center">
                            <span
                                matTooltip="Indicator of field change"
                                i18n-matTooltip
                                class="cell-indicator"
                                [ngClass]="{ green: resourceForm.get('price').dirty }"
                            ></span>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div
                        class="mb-2"
                        fxLayoutGap.gt-md="2em"
                        fxLayout.lt-md="column"
                        fxFlex="0 1 100%"
                        [fxHide]="false"
                    >
                        <mat-form-field fxFlex="0 0 40%" fxLayout.lt-md="0 0 90%">
                            <input
                                matInput
                                type="number"
                                min="0"
                                placeholder="Please set course price"
                                i18n-placeholder
                                formControlName="price"
                            />
                        </mat-form-field>
                        <mat-select
                            class="select-curr"
                            fxFlex="0 0 40%"
                            fxLayout.lt-md="0 0 90%"
                            placeholder="Place choose currency"
                            i18n-placeholder
                            formControlName="currency"
                        >
                            <mat-option *ngFor="let currency of currencies" [value]="currency.code">
                                {{ currency.label }} - {{ currency.sign }}
                            </mat-option>
                        </mat-select>
                    </div>
                </mat-expansion-panel>
            </mat-expansion-panel>
            <ng-container *ngIf="customFields$ | async as customFields">
                <ng-container *ngIf="customFields && customFields.length > 0">
                    <app-resources-custom-fields
                        [resource]="resource"
                        [customFields]="customFields"
                    ></app-resources-custom-fields>
                </ng-container>
            </ng-container>
        </div>
    </mat-expansion-panel>
</mat-accordion>
<ng-template #smallLoading>
    <div fxLayout="row" fxLayoutAlign="start center" class="spinner-container mt-2">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>
<ng-template #uploadImg let-control="control" let-label="label">
    <app-media
        #app_media
        fxFlex="1 1 50%"
        fxFlex.lt-md="1 1 100%"
        [formControl]="resourceForm.get(control) | cast"
        [scope]="AppScope.COURSE"
        [hasAIUploader]="true"
        [dropLabel]="label"
        i18n-dropLabel
        (onMediaUpdated)="onMediaUpdated($event, control)"
    ></app-media>

    <!-- <div fxFlex="0 0 50%" fxFlex.lt-md="0 0 90%" class="media-area" fxLayout="column" fxLayoutAlign="center center">
        <input
            #uploadInput
            class="media-upload-button"
            type="file"
            (change)="fileHandler($event, control)"
            [disabled]="saving"
            accept="image/png, image/jpeg"
        />
        <p>{{ label }}</p>
        <button mat-raised-button (click)="uploadInput.click()" color="primary" i18n>Upload File</button>
    </div>
    <div class="progress-wrapper mt-1" *ngIf="progress$ | async; let progress">
        <mat-progress-bar class="progress" mode="determinate" [value]="progress"></mat-progress-bar>
        <span class="progress-value">{{ progress }}%</span>
    </div> -->
</ng-template>
<ng-template #authorsAddingTemplate>
    <app-resource-manager-author-handler
        [educatorRole]="ResourceStaffRoles.MANAGER"
        [resource]="resource"
        formControlName="manager"
        educatorLabel="Author"
        i18n-educatorLabel
    ></app-resource-manager-author-handler>
</ng-template>
